export default {
  user: {},
  result: {},
  groupUsers: {},
  token: '',
  isAuthenticated: false,
  permissionsList: [],
  isSuperAdmin: false,
  notifications: [],
  groups: [],
  selfDashboards: [],
  adminUsers: [],
  isUserInvited: false,
  message: '',
  projectList: [],
  userLogOut: {},
  users: [],
  licenses: [],
  license: {},
  tier: {},
  tiers: [],
  CustomersList:[],
  tierCount: 0,
};
